import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_TARIFF_VALUE } from "config/constants";

export interface ITaxiClassState {
  value: string;
}

const initialState: ITaxiClassState = {
  value: DEFAULT_TARIFF_VALUE,
};

export const taxiClassSlice = createSlice({
  name: "taxiClass",
  initialState,
  reducers: {
    setTaxiClass: (state, { payload }) => {
      state.value = payload.value;
    },
    setInitialTaxiClass: (state) => {
      state.value = DEFAULT_TARIFF_VALUE;
    },
  },
});

export const { setTaxiClass, setInitialTaxiClass } = taxiClassSlice.actions;
export default taxiClassSlice.reducer;
